import PartnershipsPage from 'components/pages/admin/partnerships/partnerships-page'
export default PartnershipsPage
